export enum Severity {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info',
}
